/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

import { societyIcon } from '@europrocurement/l2d-icons';
import FormModal from '../../../../../../Achats/components/modals/FormModal/FormModal';

import { AVAILABLE_SOCIETIES } from '../../constants/societyData';
import { SocietyEnumValue } from '../../types/reminderPublisherTypes';

type SocietySelectorProps = {
    selectedSociety: SocietyEnumValue | null;
    isProcessing: boolean;
    onSelectionChange: (value: SocietyEnumValue | null, checked: boolean) => void;
    onCancel: () => void;
    onContinue: () => void;
};

const SocietySelector: React.FunctionComponent<SocietySelectorProps> = function ({
    selectedSociety,
    isProcessing,
    onSelectionChange,
    onCancel,
    onContinue,
}: SocietySelectorProps) {
    const choices = React.useMemo(
        () => [
            ...AVAILABLE_SOCIETIES.map((society) => ({
                label: society.label,
                value: society.id.toString(),
                action: (_: any, checked: boolean) => {
                    if (checked) {
                        onSelectionChange(society.id as SocietyEnumValue, checked);
                    }
                },
                defaultSelected: selectedSociety === society.id,
            })),
        ],
        [onSelectionChange, selectedSociety],
    );

    return (
        <FormModal
            inputNature="select"
            title="Choix de la société"
            context="Sélectionnez une société pour filtrer les suggestions de rappels ou continuez sans filtre pour voir toutes les suggestions."
            choices={choices}
            icon={societyIcon}
            uniqChoice
            submitActions={[
                {
                    type: 'cancel',
                    action: onCancel,
                    label: 'Annuler',
                    disabled: isProcessing,
                },
                {
                    type: 'confirm',
                    action: () => {
                        onContinue();
                    },
                    label: 'Continuer',
                    disabled: isProcessing,
                },
            ]}
        />
    );
};

export default SocietySelector;
